export default __webpack_public_path__ + "static/media/EmployeeOnboardingIcon.501fc726.svg";